import React from "react";
import { Button } from "@dippi/ui";
import { Dialog, DialogTitle, DialogActions } from "@mui/material";
import { useUsageModal } from "./hooks";

interface Props {
    open: boolean;
    onClose: () => void;
}

const ResetLabelsModal: React.FC<Props> = ({ open, onClose }) => {
    const { onReset } = useUsageModal();

    const handleReset = () => {
        onReset();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="reset-labels-title"
            PaperProps={{
            sx: {
                px: 4,
                py: 3,
                borderRadius: 2,
            },
            }}
        >
            <DialogTitle
            id="reset-labels-title"
            sx={{ textAlign: "center", pb: 1 }}
            >
            Confirm Reset Labels
            </DialogTitle>
            <DialogActions sx={{ justifyContent: "center", gap: 2, pt: 2 }}>
            <Button variant="outlined" onClick={onClose}>
                Cancel
            </Button>
            <Button
                variant="contained"
                onClick={handleReset}
                sx={{
                    "&.MuiButtonBase-root": {
                        backgroundColor: "primary.main"
                    }
                }}
            >
                Reset labels
            </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ResetLabelsModal;
